(ns practitest.frontend.common.fetch
  (:require
    [practitest.frontend.common.dom :as dom]))

(defn pt-fetch
  "Wraps js/fetch with session-auth defaults (CSRF, credentials, JSON headers).

  Parameters:
    - `url`: URL.
    - `opts`: Options map with following keys:
      - `:method`: HTTP verb (default \"GET\").
      - `:body`: Clojure map that gets JSON-stringified. Omit for GET.

  Returns promise."
  [url {:keys [method body] :or {method "GET"}}]
  (let [opts (cond-> {:method method
                      :headers {"X-CSRF-Token" (dom/csrf-token)
                                "Content-Type" "application/json"
                                "Accept" "application/json"}
                      :credentials "include"}
               body (assoc :body (js/JSON.stringify (clj->js body))))]
    (js/fetch url (clj->js opts))))

(defn fetch-json
  "pt-fetch + parse response body as keywordized JSON.

  Returns a promise of {:status :ok? :body}."
  [url opts]
  (-> (pt-fetch url opts)
      (.then (fn [resp]
               (-> (.json resp)
                   (.then (fn [body]
                            {:status (.-status resp)
                             :ok? (.-ok resp)
                             :body (js->clj body :keywordize-keys true)})))))))
